// import redux and persist plugins
import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { persistReducer } from 'reduxjs-toolkit-persist';
import storage from 'reduxjs-toolkit-persist/lib/storage';
import persistStore from 'reduxjs-toolkit-persist/es/persistStore';
import { FLUSH, PAUSE, PERSIST, PURGE, REGISTER, REHYDRATE } from 'reduxjs-toolkit-persist/es/constants';

// import theme reducers
import settingsReducer from 'settings/settingsSlice';
import layoutReducer from 'layout/layoutSlice';
import langReducer from 'lang/langSlice';
import authReducer from 'auth/authSlice';
import menuReducer from 'layout/nav/main-menu/menuSlice';
import notificationReducer from 'layout/nav/notifications/notificationSlice';
import scrollspyReducer from 'components/scrollspy/scrollspySlice';


// import persist key
import { REDUX_PERSIST_KEY } from 'config.js';
import RegisterReducer from 'Redux/PublisherRedux/RegisterRedux/Register';
import ClassificationReducer from 'Redux/PublisherRedux/ClassificationsRedux/classifications';
import NewManuscriptReducer from 'Redux/PublisherRedux/NewManuscriptRedux/NewManuscriptRedux';
import SubmitManuscriptReducer from 'Redux/AuthorRedux/SubmitmanuscriptRedux/submitmanuscriptRedux';
import ContactQueryReducer from 'Redux/PublisherRedux/ContactQueryRedux/ContactQuery';
import CompletedArticleReducer from 'Redux/PublisherRedux/CompletedArticles/completedArticles';
import AuthorArticleReducer from 'Redux/AuthorRedux/SubmitmanuscriptRedux/AuthorArticleRedux/AuthorArticleRedux';
import AuthorDashboardReducer from 'Redux/AuthorRedux/DashboardRedux/authorDashBoard';
import ArticlesReducer from 'Redux/PublisherRedux/Articles/articles';
import InboxReducer from 'Redux/PublisherRedux/publisherInboxRedux/inbox';
import ReviewerArticleReducer from 'Redux/ReviewerRedux/ReviewerArticle/ReviewerArticleRedux';
import ReviewerDashboardReducer from 'Redux/ReviewerRedux/ReviewerDashboardRedux/ReviewerDashboardRedux';
import EditorDashboardReducer from 'Redux/EditorRedux/EditorDashboard/EditorDashboardRedux';
import NotificationReducer from 'Redux/PublisherRedux/NotificationsRedux/notifications';
import AuthorNotifyReducer from 'Redux/PublisherRedux/AthorNotify/authorNotify';
import PublishedArticleReducer from 'Redux/PublisherRedux/CompletedArticles/alreadyPublishedArticle';
import EditorArticleReducer from 'Redux/EditorRedux/EditorArticleRedux/EditorArticleRedux';
import PreqcRejectReducer from 'Redux/PublisherRedux/PreqcReject/preqcRejectRedux';
import TransactionListReducer from 'Redux/PublisherRedux/TransactionRedux/Transactionlist';


const persistConfig = {
  key: REDUX_PERSIST_KEY,
  storage,
  // whitelist: ['menu', 'settings', 'lang', 'auth'],
};

const persistedReducer = persistReducer(
  persistConfig,
  combineReducers({
    settings: settingsReducer,
    layout: layoutReducer,
    lang: langReducer,
    auth: authReducer,
    menu: menuReducer,
    notification: notificationReducer,
    scrollspy: scrollspyReducer,
    register: RegisterReducer,
    classifications: ClassificationReducer,
    newmanuscript: NewManuscriptReducer,
    submitmanuscript: SubmitManuscriptReducer,
    newmanuscript: NewManuscriptReducer,
    contact: ContactQueryReducer,
    articles: CompletedArticleReducer,
    authorarticle: AuthorArticleReducer,
    authordashboard: AuthorDashboardReducer,
    articleslist: ArticlesReducer,
    inboxlist: InboxReducer,
    reviewerarticle:ReviewerArticleReducer,
    reviewerdashboard:ReviewerDashboardReducer,
    editordashboard:EditorDashboardReducer,
    notifylist: NotificationReducer,
    authornotify: AuthorNotifyReducer,
    publishedarticles: PublishedArticleReducer,
    editorarticle:EditorArticleReducer,
    preqclist:PreqcRejectReducer,
    transactionadminlist:TransactionListReducer,
  })
);
const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});
const persistedStore = persistStore(store);
export { store, persistedStore };
